import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'labelMap',
    standalone: false
})
export class LabelMapPipe implements PipeTransform {
  transform(label: any, mapping?: any): any {
    if (mapping && label in mapping) {
      return mapping[label]
    }
    return label
  }
}
